import React from 'react'
import PropTypes from 'prop-types'
import * as UI from './Common.styles'

const Article = ({ className, imageUrl, name, url }) =>
  <UI.Block className={ className } data-at-globalsearch-article>
    <UI.Table>
      <UI.Image data-at-globalsearch-article-image full src={ imageUrl } alt="" />
      <UI.Info>
        <UI.Name data-at-globalsearch-article-link to={ url }>{ name }</UI.Name>
      </UI.Info>
    </UI.Table>
  </UI.Block>

Article.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string
}

export default Article
